export default __webpack_public_path__ + "static/media/fphoto2.553f2d17.jpeg";